<script setup lang="ts">
  import { inject, useCssModule } from 'vue';

  import { RADIO_GROUP_INJECTION } from '../RadioGroup.keys';

  const radioGroupInjection = inject(RADIO_GROUP_INJECTION.key);

  if (!radioGroupInjection) {
    throw new Error('VariantChip must be used with a RadioGroup instance.');
  }

  const { name, disabled, fullWidth, modelValue, options, update } = radioGroupInjection;
  const classes = useCssModule();
</script>

<template>
  <div class="my-1.5 flex flex-wrap" :class="classes.root">
    <div v-for="option in options" :key="`${name}-${option.id}`" :class="[{ 'w-full': fullWidth }]">
      <input
        :id="`${name}-${option.id}`"
        class="sr-only"
        type="radio"
        :name="name"
        :value="option.value"
        :checked="modelValue === option.value"
        :disabled="disabled || option.disabled"
        @input="update"
      />
      <label :for="`${name}-${option.id}`">
        {{ option.text }}
      </label>
    </div>
  </div>
</template>

<style module>
  @reference "../../../../styles/main.css";

  .root {
    gap: --spacing(6);
  }

  .root label {
    padding: --spacing(1.5) --spacing(3);
    border: 1px solid var(--color-ice-500);
    font-weight: var(--stash-font-weight-normal);
    color: var(--color-ice-900);
    cursor: pointer;
    transition: all 0.2s;
    user-select: none;
    border-radius: 9999px;
    white-space: nowrap;
  }

  .root input:disabled ~ label {
    background-color: var(--color-ice-200);
    color: var(--color-ice-500);
    cursor: auto;
  }

  .root input:checked:not(:disabled) ~ label {
    border-color: var(--color-blue-500);
    color: var(--color-white);
    background-color: var(--color-blue-500);
    font-weight: var(--stash-font-weight-semibold);
  }

  .root input:not(:checked, :disabled) ~ label:hover {
    border-color: var(--color-blue-500);
  }
</style>
